import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotPicks from './components/HotPicks';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import NewsletterSection from './components/NewsletterSection';
import SEOHead, { OrganizationSchema, WebsiteSchema } from '@/components/base/SEOHead';
import { Link } from 'react-router-dom';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '九妖漫画网 - 首页',
    description: '九妖漫画网官网网页版登录入口，免费在线看漫画全集，高清无删减资源，让您一站式阅读所有漫画。',
    url: 'https://www.jiuyaomanhua.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '九妖漫画网',
      url: 'https://www.jiuyaomanhua.com/',
    },
    about: {
      '@type': 'Organization',
      name: '九妖漫画网',
    },
  };

  return (
    <>
      <SEOHead
        title="九妖漫画网官网-网页版登录入口，免费在线看漫画全集"
        description="九妖漫画网官网网页版登录入口，免费在线看漫画全集，高清无删减资源，让您一站式阅读所有漫画。每日更新热门漫画，涵盖热血、恋爱、玄幻、悬疑等多种类型。"
        keywords="九妖漫画网,官网,网页版登录入口,免费在线看,漫画全集,高清漫画,在线漫画,免费漫画"
        canonicalUrl="https://www.jiuyaomanhua.com/"
        breadcrumbs={[{ label: '首页', href: '/' }]}
        schema={homeSchema}
      />
      <OrganizationSchema />
      <WebsiteSchema />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotPicks />
          <CategorySection />
          <LatestUpdates />

          <section className="py-14 bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  为什么选择九妖漫画网？
                </h2>
                <p className="text-sm text-foreground-500 mt-2">数百万读者的共同选择</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-stack-line', title: '海量资源', desc: '收录数万部热门漫画，涵盖各种类型，满足多元阅读需求' },
                  { icon: 'ri-hd-line', title: '高清画质', desc: '所有漫画均为高清版本，确保每一页都清晰锐利' },
                  { icon: 'ri-refresh-line', title: '极速更新', desc: '与出版社同步更新，第一时间为您带来最新章节' },
                  { icon: 'ri-shield-check-line', title: '完全免费', desc: '承诺所有漫画资源永久免费，无需付费订阅' },
                ].map((item) => (
                  <div key={item.title} className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center hover:border-primary-200 transition-all duration-300">
                    <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                      <i className={`${item.icon} text-2xl text-primary-500`}></i>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>

              <div className="text-center mt-10">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  了解更多关于我们
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          <RankingSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}